import { render } from "./CertificatesPopup.vue?vue&type=template&id=6fc4cb92&scoped=true"
import script from "./CertificatesPopup.vue?vue&type=script&lang=js"
export * from "./CertificatesPopup.vue?vue&type=script&lang=js"

import "./CertificatesPopup.vue?vue&type=style&index=0&id=6fc4cb92&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc4cb92"]])

export default __exports__